import { instance } from 'api/core';


export const unassignLocationFromStation = async (
    stationId: string,
    callback: { success: () => void; error?: (err: any) => void }
) => {
    try {
        await instance.patch(`/asrs/stations/${stationId}/unassign-location`);
        callback.success();
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};